import { render, staticRenderFns } from "./SaveSearchPopup.vue?vue&type=template&id=36fa3c35&scoped=true&"
import script from "./SaveSearchPopup.vue?vue&type=script&lang=ts&"
export * from "./SaveSearchPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SaveSearchPopup.vue?vue&type=style&index=0&id=36fa3c35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa3c35",
  null
  
)

export default component.exports